import { App } from '@openedx/frontend-base';
import { addScript, addSlot } from './utils';

const customApp: App = {
  appId: 'custom',
};
import { WidgetOperationTypes } from '@openedx/frontend-base';
const setCookieFunction = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  let domain_parts = (window.location.hostname + '').split('.');
  domain_parts.shift();
  let domain = "";
  domain = "; domain=." + domain_parts.join('.');
  document.cookie = name + "=" + value + expires + domain + "; path=/";
  window.location.reload();
};

const getLanguage = () => {
  // Fonction utilitaire pour normaliser les codes de langue
  const normalizeLang = (lang) => {
    if (!lang) return null;

    const lower = lang.toLowerCase();

    if (lower === 'fr' || lower.startsWith('fr-')) {
      return 'fr-ca';
    }

    if (lower === 'en' || lower.startsWith('en-')) {
      return 'en';
    }

    return null;
  };

  // On essaye d'abord de récupérer la langue depuis le cookie
  const languageCookie = document.cookie.split('; ').find((cookie) => cookie.startsWith('openedx-language-preference='));
  const languageFromCookie = languageCookie ? decodeURIComponent(languageCookie.split('=')[1]) : null;
  const fromCookie = normalizeLang(languageFromCookie);
  if (fromCookie) {
    if (fromCookie != languageFromCookie) setCookieFunction('openedx-language-preference', fromCookie, 14);
    return fromCookie;
  }

  // Ensuite, on essaye de récupérer la langue depuis le navigateur
  const browserLang = navigator.languages?.[0] || navigator.language || null;
  const fromBrowser = normalizeLang(browserLang);
  if (fromBrowser) {
    if (fromBrowser != browserLang) setCookieFunction('openedx-language-preference', fromBrowser, 14);
    return fromBrowser;
  }

  // Par défaut, on retourne 'fr-ca'
  return 'fr-ca';
};

const language = getLanguage();

const langIsFrench = () => {
  return language === "fr-ca";
};

const toggleLanguage = () => {
  if (langIsFrench()) {
    setCookieFunction('openedx-language-preference', 'en', 14);
  }
  else {
    setCookieFunction('openedx-language-preference', 'fr-ca', 14);
  }
}

const pageTitle = document.title;

const pageBack = () => {
  window.history.back();
};


const languages = {
  "fr-ca": {
    help: "Aide",
    contact: "NOUS CONTACTER",
    about: "À propos",
    terms: "Conditions d'utilisation",
    policies: "Politiques et publications",
    poweredBy: "Propulsé par",
    wiki: "WIKI TECHNIQUE",
    serverstatus: "ETAT DES SERVEURS",
    bulletins: "BULLETINS D'INFORMATION",
    langswitch: "ENGLISH",
    langswitchcode: 'javascript:setLanguage("en")',
    bannerwelcome: "Bienvenue sur evolo",
    bannerplatform: "la plateforme de formation gratuite de Calcul Québec destinée à la communauté de la recherche.",
    bannercomeback: "Revenez régulièrement : de nouveaux cours sont en préparation !",
    sla: "Accord de niveau de service",
  },
  en: {
    help: "Help",
    contact: "CONTACT US",
    about: "About",
    terms: "Terms of use",
    policies: "Policies and publications",
    poweredBy: "Powered by",
    wiki: 'TECHNICAL WIKI',
    serverstatus: "SERVER STATUS",
    bulletins: "SUBSCRIBE TO OUR NEWSLETTERS",
    langswitch: "FRANÇAIS",
    langswitchcode: 'javascript:setLanguage("fr-ca")',
    bannerwelcome: "Welcome to evolo",
    bannerplatform: "Calcul Québec's free learning platform aimed at the research community.",
    bannercomeback: "Come back often: new content is being prepared!",
    sla: "Service level agreement",
  },
};
class ExternalScriptsLoader {
  externalScripts = {};
  constructor({ config }) {
    this.externalScripts = config['EXTERNAL_SCRIPTS'];
  }

  loadScript() {
    if (!this.externalScripts) {
      return;
    }
    for (var i = 0, keys = Object.keys(this.externalScripts), ii = keys.length; i < ii; i++) {
      const script = document.createElement('script');
      script.id = keys[i];
      script.src = this.externalScripts[keys[i]]['src'];
      script.type = 'text/javascript';
      if ("defer" in this.externalScripts[keys[i]]) {
        script.defer = 'defer' in this.externalScripts[keys[i]];
        document.body.appendChild(script);
      }
      else {
        document.head.appendChild(script);
      }
    }
  }
}
class ExternalStylesheetsLoader {
  externalSheets = {}
  constructor({ config }) {
    this.externalSheets = config['EXTERNAL_STYLESHEETS'];
  }

  loadScript() {
    if (!this.externalSheets) {
      return;
    }
    for (var i = 0, keys = Object.keys(this.externalSheets), ii = keys.length; i < ii; i++) {
      const stylesheet = document.createElement('link');
      stylesheet.id = keys[i];
      stylesheet.rel = 'stylesheet';
      stylesheet.type = 'text/css';
      stylesheet.href = this.externalSheets[keys[i]];
      document.head.appendChild(stylesheet);
    }
  }
}
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Spinner } from '@openedx/paragon';
import { getAuthenticatedHttpClient, getSiteConfig } from '@openedx/frontend-base';

interface VoteAggregate {
  scale_text: string;
  count: number;
}

interface Answer {
  username: string;
  user_vote: string;
  user_freeform: string;
}

interface FeedbackBlock {
  display_name: string;
  prompts: Record<string, any>;
  vote_aggregate: VoteAggregate[];
  answers: Answer[];
  unit_display_name: string;
  subsection_display_name: string;
  section_display_name: string;
  average_rating: number;
  url: string;
}

const PlaceholderSlot = (_props: Record<string, any>) => null;

const FeedbackTab = () => {
  const { courseId } = useParams<{ courseId: string }>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [blocks, setBlocks] = useState<FeedbackBlock[]>([]);

  const isFrench = typeof langIsFrench === 'function' ? langIsFrench() : false;

  const t = {
    title: isFrench ? 'Rétroaction sur le cours' : 'Course Feedback',
    component: isFrench ? 'Composante' : 'Component',
    ratingsCount: isFrench ? "Nombre d'évaluations" : 'Number of ratings',
    averageRating: isFrench ? 'Note moyenne' : 'Average rating',
    comments: isFrench ? 'Commentaires' : 'Feedback / Comments',
    noRatings: isFrench ? 'Aucune évaluation' : 'No ratings',
    noComments: isFrench ? 'Aucun commentaire' : 'No comments',
    noBlocks: isFrench
      ? 'Aucune composante de rétroaction trouvée dans ce cours.'
      : 'No feedback components found in this course.',
    loadError: isFrench
      ? 'Erreur lors du chargement de la rétroaction.'
      : 'Failed to load course feedback.',
  };

  useEffect(() => {
    if (!courseId) {
      setLoading(false);
      return;
    }

    const { lmsBaseUrl } = getSiteConfig();
    const endpoint = `${lmsBaseUrl || ''}/api/feedback/v1/courses/${courseId}/`;

    getAuthenticatedHttpClient()
      .get<{ course_id: string; blocks: FeedbackBlock[] }>(endpoint)
      .then((res) => {
        setBlocks(res.data?.blocks || []);
        setLoading(false);
      })
      .catch((err) => {
        const errorMsg =
          err?.response?.data?.error ||
          err?.message ||
          t.loadError;
        setError(errorMsg);
        setLoading(false);
      });
  }, [courseId]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center my-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="my-4">
        <Alert variant="danger">{error}</Alert>
      </div>
    );
  }

  if (!blocks || blocks.length === 0) {
    return (
      <div className="my-4">
        <Alert variant="info">{t.noBlocks}</Alert>
      </div>
    );
  }

  const colComponentStyle = { width: '30%' };
  const colRatingsStyle = { width: '25%' };
  const colAverageStyle = { width: '15%' };
  const colCommentsStyle = { width: '30%' };

  return (
    <div className="feedback-instructor-wrapper my-4">
      <h3 className="mb-4">{t.title}</h3>
      <div className="table-responsive">
        <table className="table table-striped table-hover table-bordered">
          <thead className="table-light">
            <tr>
              <th scope="col" style={colComponentStyle}>{t.component}</th>
              <th scope="col" style={colRatingsStyle}>{t.ratingsCount}</th>
              <th scope="col" style={colAverageStyle}>{t.averageRating}</th>
              <th scope="col" style={colCommentsStyle}>{t.comments}</th>
            </tr>
          </thead>
          <tbody>
            {blocks.map((block, idx) => (
              <tr key={idx}>
                <td>
                  <a
                    href={block.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fw-bold"
                  >
                    {[
                      block.section_display_name,
                      block.subsection_display_name,
                      block.unit_display_name,
                      block.display_name,
                    ]
                      .filter(Boolean)
                      .join(' > ')}
                  </a>
                </td>
                <td>
                  {block.vote_aggregate && block.vote_aggregate.length > 0 ? (
                    <ul className="list-unstyled mb-0">
                      {block.vote_aggregate.map((vote, vIdx) => (
                        <li key={vIdx}>
                          <span className="fw-semibold">{vote.scale_text}:</span> {vote.count}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span className="text-muted">{t.noRatings}</span>
                  )}
                </td>
                <td>
                  <span className="badge bg-primary fs-6">
                    {block.average_rating}
                  </span>
                </td>
                <td>
                  {block.answers && block.answers.length > 0 ? (
                    <ul className="list-unstyled mb-0">
                      {block.answers.map((ans, aIdx) => (
                        <li key={aIdx} className="mb-2 pb-2 border-bottom">
                          <span className="badge bg-secondary me-2">
                            {ans.user_vote}
                          </span>
                          <span>{ans.user_freeform}</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span className="text-muted">{t.noComments}</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
addSlot(customApp, 
            {
              slotId: 'org.openedx.frontend.slot.header.desktop.v1',
              op: WidgetOperationTypes.REMOVE,
              relatedId: 'defaultContent'
            }
            );
addSlot(customApp, 
            {
              slotId: 'org.openedx.frontend.slot.header.mobile.v1',
              op: WidgetOperationTypes.REMOVE,
              relatedId: 'defaultContent'
            }
            );
addSlot(customApp, 
            {
              slotId: 'org.openedx.frontend.slot.footer.desktop.v1',
              op: WidgetOperationTypes.REMOVE,
              relatedId: 'org.openedx.frontend.widget.footer.desktopLayout.v1'
            }
            );
addSlot(customApp, 
            {
              slotId: 'org.openedx.frontend.slot.header.secondaryLinks.v1',
              op: WidgetOperationTypes.REMOVE,
              relatedId: 'org.openedx.frontend.widget.header.help.v1'
            }
            );
addSlot(customApp, 
            {
              slotId: 'org.openedx.frontend.slot.header.desktop.v1',
              op: WidgetOperationTypes.APPEND,
              id: 'custom_org.openedx.frontend.slot.header.desktop.v1',
              element: (
                  <>
    <script src='https://kit.fontawesome.com/91003a351d.js' crossOrigin='anonymous'></script>
    <div>
      <div className='banner'>
        <div className='cover-filter'></div>
        <img
          src='https://edx.evolo.calculquebec.cloud/asset-v1:CQ+Assets101+2026+type@asset+block@logo_bandeau.png'
          alt='Logo'
        />
      </div>
      <div className='page-back'>
        <div className='back-icon' onClick={pageBack}>
          <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
            <path d='M12.465 2.24254C12.0975 1.87504 11.505 1.87504 11.1375 2.24254L4.905 8.47504C4.6125 8.76754 4.6125 9.24004 4.905 9.53254L11.1375 15.765C11.505 16.1325 12.0975 16.1325 12.465 15.765C12.8325 15.3975 12.8325 14.805 12.465 14.4375L7.035 9.00004L12.4725 3.56254C12.8325 3.20254 12.8325 2.60254 12.465 2.24254Z' />
          </svg>
        </div>
        <h2 className='page-title'>{pageTitle.split('|')[0].trim()}</h2>
      </div>
    </div>
  </>

              )
            }
            );
addSlot(customApp, 
            {
              slotId: 'org.openedx.frontend.slot.footer.desktop.v1',
              op: WidgetOperationTypes.APPEND,
              id: 'custom_org.openedx.frontend.slot.footer.desktop.v1',
              element: (
                  <>
    <script src="https://kit.fontawesome.com/91003a351d.js" crossOrigin="anonymous"></script>
    <footer className="footer">
      <div className="plugins"></div>
      <div className="container">
        <ul className="footer__nav fll ul-reset">
          <li className="footer__list-item">
            <a
              href={
                langIsFrench()
                  ? 'https://docs.alliancecan.ca/wiki/Technical_documentation/fr'
                  : 'https://docs.alliancecan.ca/wiki/Technical_documentation'
              }
              target="_blank"
              rel="noopener noreferrer"
              className="footer__link"
            >
              {languages[language].wiki}
            </a>
          </li>
          <li className="footer__list-item">
            <a href="https://status.alliancecan.ca" target="_blank" rel="noopener noreferrer" className="footer__link">
              {languages[language].serverstatus}
            </a>
          </li>
          <li className="footer__list-item">
            <a
              href={
                langIsFrench()
                  ? 'https://www.calculquebec.ca/salles-de-presses/infolettres/'
                  : 'https://www.calculquebec.ca/en/pressroom/subscribe-to-our-newsletter/'
              }
              target="_blank"
              rel="noopener noreferrer"
              className="footer__link"
            >
              {languages[language].bulletins}
            </a>
          </li>
          <li className="footer__list-item">
            <a href="mailto:formation@calculquebec.ca" target="_blank" rel="noopener noreferrer" className="footer__link">
              {languages[language].contact}
            </a>
          </li>
          <li className="footer__list-item">
            <a
              href="#"
              onClick={toggleLanguage}
              className="footer__link"
            >
              {languages[language].langswitch}
            </a>
          </li>
        </ul>
      </div>
    </footer>
    <div className="post-footer">
      <div className="post-footer-wrapper">
        <a href={langIsFrench() ? 'https://www.alliancecan.ca//fr/' : 'https://www.alliancecan.ca//'} target="_blank" rel="noopener noreferrer">
          <img src="https://www.calculquebec.ca/wp-content/uploads/2022/04/Alliance_partner_logo_Regional-French-first.svg" alt="Partenaire de l'Alliance" />
        </a>
        <a href="https://www.quebec.ca" target="_blank" rel="noopener noreferrer">
          <img src="https://www.calculquebec.ca/wp-content/themes/calcul_quebec/assets/img/logo-quebec-v2.png" alt="Gouvernement du Québec" />
        </a>
        <a href="https://frq.gouv.qc.ca/" target="_blank" rel="noopener noreferrer">
          <img src="https://www.calculquebec.ca/wp-content/themes/calcul_quebec/assets/img/fond_de_recherche_du_quebec.png" alt="Fonds de recherche du Québec" />
        </a>
      </div>
    </div>
    <div className="line"></div>
    <div className="bottom">
      <p className="desktop">&copy; Calcul Québec 2026</p>
      <ul className="bottom-links">
        <li>
          <a
            href={
              langIsFrench()
                ? 'https://www.calculquebec.ca/conditions-utilisation'
                : 'https://www.calculquebec.ca/terms-use'
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            {languages[language].terms}
          </a>
        </li>
        <li>
          <a
            href={
              langIsFrench()
                ? '/ans'
                : '/ans'
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            {languages[language].sla}
          </a>
        </li>
        <li>
          <a
            href={
              langIsFrench()
                ? 'https://www.calculquebec.ca/a-propos/politiques-et-publications/'
                : 'https://www.calculquebec.ca/en/about-us/policies-and-publications/'
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            {languages[language].policies}
          </a>
        </li>
      </ul>
      <ul className="logo-list">
        <li className="powered">{languages[language].poweredBy}</li>
        <li>
          <a href="https://docs.tutor.edly.io" rel="noopener noreferrer" target="_blank">
            <img
              src="https://repository-images.githubusercontent.com/96100263/4f41d9c4-98d1-4934-a681-47b4f0917f78"
              alt="Runs on Tutor"
              width="57"
            />
          </a>
        </li>
        <li className="vertical-line"></li>
        <li className="openedx">
          <a href="https://openedx.org/" rel="noopener noreferrer" target="_blank">
            <img src="https://logos.openedx.org/edx-openedx-logo-tag.png" alt={languages[language].poweredBy + ' Open edX'} width="110" />
          </a>
        </li>
      </ul>
      <p className="mobile">&copy; Calcul Québec 2026</p>
    </div>
  </>

              )
            }
            );
addSlot(customApp, 
            {
              slotId: 'org.openedx.frontend.slot.instructorDashboard.routes.v1',
              op: WidgetOperationTypes.APPEND,
              id: 'custom_org.openedx.frontend.slot.instructorDashboard.routes.v1',
              element: (
                <PlaceholderSlot tabId="feedback" content={<FeedbackTab />} />
              )
            }
            );
addScript(customApp, ExternalScriptsLoader);
addScript(customApp, ExternalStylesheetsLoader);

export default customApp;